import ReactMarkdown from "react-markdown";
import { Copy, Check } from "@phosphor-icons/react";
import { getPlatformStyle } from "@/lib/repurposeConstants";

export function ResultCard({ result, copied, onCopy, savedIndicator }) {
  const style = getPlatformStyle(result.target_platform);

  return (
    <div className="space-y-3">
      {result.what_changed && (
        <div className="bg-[var(--bg-base)] rounded-md p-3">
          <p className="text-[10px] font-['JetBrains_Mono'] uppercase tracking-[0.2em] text-[var(--text-muted)] mb-1">What Changed</p>
          <p className="text-sm text-[var(--text-secondary)]">{result.what_changed}</p>
        </div>
      )}

      <div className="bg-[var(--bg-base)] border border-[#FF4400]/20 rounded-md p-4">
        <div className="flex items-center justify-between mb-3">
          <div className="flex items-center gap-2">
            <p className="text-xs font-['JetBrains_Mono'] uppercase tracking-[0.2em] text-[#FF4400]">
              {result.target_type}
            </p>
            <span className="text-[10px] px-2 py-0.5 rounded-full bg-[var(--bg-raised)] text-[var(--text-muted)] border border-[var(--border)]">
              {style.hint}
            </span>
          </div>
          <button onClick={onCopy}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-md bg-[#FF4400] text-white text-xs hover:bg-[#FF6633] transition-colors"
            data-testid="repurpose-copy-button">
            {copied ? <Check size={14} /> : <Copy size={14} />}
            {copied ? "Copied!" : "Copy"}
          </button>
        </div>

        <div
          className="prose prose-sm max-w-none text-[var(--text-primary)] text-sm leading-relaxed mx-auto prose-headings:text-[var(--text-primary)] prose-strong:text-[var(--text-primary)] prose-p:text-[var(--text-primary)]"
          style={{ fontFamily: style.font, maxWidth: style.maxWidth, lineHeight: style.lineHeight }}
          data-testid="repurpose-formatted-content"
        >
          <ReactMarkdown>{result.repurposed_content}</ReactMarkdown>
        </div>
      </div>

      {result.what_was_preserved && (
        <div className="bg-[var(--bg-base)] rounded-md p-3">
          <p className="text-[10px] font-['JetBrains_Mono'] uppercase tracking-[0.2em] text-[var(--text-muted)] mb-1">Core Preserved</p>
          <p className="text-sm text-[var(--text-secondary)]">{result.what_was_preserved}</p>
        </div>
      )}

      {savedIndicator && (
        <p className="text-xs text-[var(--success)] font-['JetBrains_Mono']" data-testid="repurpose-saved-indicator">Saved to history</p>
      )}
    </div>
  );
}
